export var DOCUMENT_LANGUAGE_MAPPING = {
    "cs-cz": "Czech",
    "da-dk": "Danish",
    "de-ch": "German",
    "de-de": "German",
    "en-apac": "English (Asia Pacific)",
    "en-au": "English",
    "en-ca": "English (Canada)",
    "en-ch": "English",
    "en-emea": "English (Europe, Middle East and Africa)",
    "en-gb": "English (UK)",
    "en-hk": "Chinese",
    "en-ie": "English",
    "en-in": "Hindi",
    "en-mea": "English (Europe, Middle East and Africa)",
    "en-no": "English",
    "en-nz": "English",
    "en-sg": "English",
    "en-us": "English",
    "es-es": "Spanish",
    "es-mx": "Latin American Spanish",
    "fi-fi": "Finnish",
    "fr-ca": "Canadian French",
    "fr-fr": "French",
    "fr-mea": "French (Europe, Middle East and Africa)",
    "it-it": "Italian",
    "ja-jp": "Japanese",
    "ko-kr": "Korean",
    "nb-no": "Norwegian",
    "nl-nl": "Dutch",
    "pl-pl": "Polish",
    "pt-br": "Brazilian Portuguese",
    "ro-ro": "Romanian",
    "sv-se": "Swedish",
    "tr-tr": "Turkish",
    "zh-cn": "Chinese Simplified",
};
